import React from "react";

const Input = (props) => {

  const onUserTypeHandler = (event) => {  
    props.onGenerateEmojifiedText(event.target.value);
  };

  return (
    <form type="text">
      <textarea
        placeholder={props.placeholder}
        onChange={onUserTypeHandler}
        rows="4"
      />
    </form> 
  );
};

export default Input;